// extracted by mini-css-extract-plugin
export default {"root":"FastDownloadTooltip_root__cWJUx"};